import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";

export const ProcessedData = ({ originalData, processedData }: { originalData: Record<string, any>, processedData: Record<string, any> }) => {
    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell sx={{ fontWeight: 600, width: '50%' }}>
                        <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            color="text.secondary"
                        >
                            Name
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, width: '50%' }}>
                        <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            color="text.secondary"
                        >
                            Original Data
                        </Typography>
                    </TableCell>
                    <TableCell
                        sx={{
                            fontWeight: 600,
                            width: '50%',
                            display: 'none',
                        }}
                    >
                        <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            color="text.secondary"
                        >
                            Processed Data
                        </Typography>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {Object.entries(originalData || {}).map(
                    ([key, value]) => {
                        const processedValue = processedData?.[key.toLowerCase()] ?? '-';
                        const isDifferent = String(value) !== String(processedValue);
                        return (
                            <TableRow key={key}>
                                <TableCell>
                                    <Typography variant="body2">{key}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">{String(value)}</Typography>
                                </TableCell>
                                <TableCell sx={{ display: 'none' }}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: isDifferent ? '#FA4616' : '#28a745',
                                            fontWeight: isDifferent ? 600 : 'normal',
                                        }}
                                    >
                                        {String(processedValue)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        );
                    },
                )}
            </TableBody>
        </Table>
    );
};